/**
 * @expFlag public-frequent-sing-up-when-downloading-ab
 * @ticket CLOUDWEB-20158
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';

export type AbPublicFrequentSingUpWhenDownloadingValues = {
    type: 'a' | 'b';
    href: string;
};

export const publicFrequentSingUpWhenDownloadingAB: AbPublicFrequentSingUpWhenDownloadingValues | false = getFeature(
    'public-frequent-sing-up-when-downloading-ab'
);
